import React, { useState } from 'react';
import { FormControl, RadioGroup, Radio, FormControlLabel, Grid, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


interface RadioFieldProps {
  name: string;
  options: { value: string | number ; label: string }[];
  label: string;
  id?: string;
  value?: string | number;
  onChange?: any;
}

const RadioField = (props: RadioFieldProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (typeof props.onChange === 'function') {
      props.onChange(e);
    }
  };

  return (
    <FormControl variant='standard' fullWidth>
      <Grid container alignItems="center">
        <Grid item xs={4}>
          <Typography variant="h4" component="p">
            <label>
              {props.label}
              <Typography variant="subtitle1" color="red" component="span">
                &nbsp;*
              </Typography>
            </label>
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <RadioGroup
            name={props.name}
            id={props.id}
            onChange={handleChange}
            value={props.value}
          >
            <Grid container>
              {props.options.map((option, index) => (
                <Grid item xs={4} key={index}>
                  <FormControlLabel
                    value={option.value}
                    control={<Radio checkedIcon={<CheckCircleIcon  />} sx={{
                      color: 'red',
                      '&.Mui-checked': {
                        color: 'red',
                      },
                    }} />}
                    label={option.label}
                    color="white"
                  />
                </Grid>
              ))}
            </Grid>
          </RadioGroup>
        </Grid>
      </Grid>
    </FormControl>
  );
};

export default RadioField;
